import React, { useState, useEffect } from "react";
import { producaov2 as api } from "../../../services/apis";

import { Icon, Modal, Button, Select, Header } from "semantic-ui-react";
import AdminMenu from "../../../components/Admin/MenuDetalhes/AdminMenu";
import {
    Container,
    Content,
    Title,
    HeaderTable,
    Form,
    SemanticTable
} from "./styles";

import { withRouter } from "react-router-dom";
import { isAuthAdmin } from "../../../services/auth";
import swal from "sweetalert";

const BarrasEventos = () => {
    const [evento, setEvento] = useState("black-2022");
    const [barras, setBarras] = useState([]);
    const [addModal, setAddModal] = useState(false);
    const [editModal, setEditModal] = useState(false);
    const [deleteModal, setDeleteModal] = useState(false);
    const [currentBarra, setCurrentBarra] = useState({
        id: 9999,
        evento: "",
        id_curso: 9999,
        vagas_disponiveis: 0,
        vagas_preenchidas: 0,
        esgotado: 0,
        atualiza: 0
    });
    const [newBarra, setNewBarra] = useState({
        evento: "",
        id_curso: 9999,
        vagas_disponiveis: 0,
        vagas_preenchidas: 0,
        esgotado: 0,
        atualiza: 0
    });

    useEffect(() => {
        loadAuth();
        loadBarras();
    }, []);

    const loadAuth = async () => {
        const auth = await isAuthAdmin();

        if (!auth) {
            localStorage.setItem("redirect", `/admin/`);
            window.location.href = "/login";
            return null;
        }
    };

    const loadBarras = async () => {
        const barras = await api.get(`/admin/barras_eventos?evento=${evento}`).then(res => { return res.data }).catch(err => { console.error(err) });

        setBarras(barras);
    }

    const validate = async (evento, id_curso, vagas_disponiveis, vagas_preenchidas) => {
        if (!evento || !id_curso || !vagas_disponiveis || !vagas_preenchidas) {
            return false;
        }

        if (vagas_preenchidas > vagas_disponiveis) {
            return false;
        }
    }

    const createBarra = async () => {
        const evento = newBarra.evento;
        const id_curso = parseInt(newBarra.id_curso);
        const vagas_disponiveis = parseInt(newBarra.vagas_disponiveis);
        const vagas_preenchidas = parseInt(newBarra.vagas_preenchidas);
        const esgotado = parseInt(newBarra.esgotado);
        const atualiza = parseInt(newBarra.atualiza);

        if (!validate(evento, id_curso, vagas_disponiveis, vagas_preenchidas)) {
            swal(
                "Erro na criação",
                "Confira se todos os campos foram preenchidos corretamente.",
                "error"
            );

            return;
        }

        await api.post("/admin/barras_eventos", {
            id_curso,
            evento,
            vagas_disponiveis,
            vagas_preenchidas,
            esgotado,
            atualiza
        }).then(res => {
            swal(
                "Barra criada com sucesso",
                "Verifique todas as barras cadastradas na tabela.",
                "success"
            );
        }).catch(err => {
            console.error(err);
            swal(
                "Erro na criação",
                "Ocorreu um erro no processamento da criação, confira os dados e tente novamente.",
                "error"
            );
            return;
        });

        setAddModal(false);
        loadBarras();
    }

    const editBarra = async () => {
        const id = parseInt(currentBarra.id);
        const evento = currentBarra.evento;
        const id_curso = parseInt(currentBarra.id_curso);
        const vagas_disponiveis = parseInt(currentBarra.vagas_disponiveis);
        const vagas_preenchidas = parseInt(currentBarra.vagas_preenchidas);
        const esgotado = parseInt(currentBarra.esgotado);
        const atualiza = parseInt(currentBarra.atualiza);

        if (!validate(evento, id_curso, vagas_disponiveis, vagas_preenchidas)) {
            swal(
                "Erro na criação",
                "Confira se todos os campos foram preenchidos corretamente.",
                "error"
            );

            return;
        }

        await api.put(`/admin/barras_eventos/${id}`, {
            id_curso,
            evento,
            vagas_disponiveis,
            vagas_preenchidas,
            esgotado,
            atualiza
        }).then(res => {
            swal(
                "Barra alterada com sucesso",
                "Verifique todas as barras cadastradas na tabela.",
                "success"
            );
        }).catch(err => {
            console.error(err);
            swal(
                "Erro na alteração",
                "Ocorreu um erro no processamento da alteração, confira os dados e tente novamente.",
                "error"
            );
            return;
        });

        setEditModal(false);
        loadBarras();
    }

    const deleteBarra = async () => {
        const id = parseInt(currentBarra.id);

        await api.delete(`/admin/barras_eventos/${id}`).then(res => {
            swal(
                "Barra excluída com sucesso",
                "Verifique todas as barras cadastradas na tabela.",
                "success"
            );
        }).catch(err => {
            console.error(err);
            swal(
                "Erro na exclusão",
                "Ocorreu um erro no processamento da exclusão, confira os dados e tente novamente.",
                "error"
            );
            return;
        });

        setDeleteModal(false);
        loadBarras();
    }

    return (
        <Container>
            <AdminMenu />

            <Content>
                <Title>Barras - Eventos</Title>

                <HeaderTable>
                    <Select onChange={e => setEvento(e.target.value)}>
                        <option selected = "black-2022" > Black-2022 </option>
                        

                    </Select>
                    <Button
                        icon="add icon"
                        color={"green"}
                        onClick={() =>
                            setAddModal(true)
                        }
                    />
                </HeaderTable>

                <SemanticTable size="big" celled>
                    <SemanticTable.Header>
                        <SemanticTable.Row>
                            <SemanticTable.HeaderCell>ID</SemanticTable.HeaderCell>
                            <SemanticTable.HeaderCell>Evento</SemanticTable.HeaderCell>
                            <SemanticTable.HeaderCell>ID curso</SemanticTable.HeaderCell>
                            <SemanticTable.HeaderCell>Vagas disponíveis</SemanticTable.HeaderCell>
                            <SemanticTable.HeaderCell>Vagas preenchidas</SemanticTable.HeaderCell>
                            <SemanticTable.HeaderCell>Esgotado?</SemanticTable.HeaderCell>
                            <SemanticTable.HeaderCell>Escala com o tempo?</SemanticTable.HeaderCell>
                            <SemanticTable.HeaderCell>Ações</SemanticTable.HeaderCell>
                        </SemanticTable.Row>
                    </SemanticTable.Header>
                    <SemanticTable.Body>
                        {barras
                            .map((barra) => (
                                <SemanticTable.Row>
                                    <SemanticTable.Cell>{barra.id}</SemanticTable.Cell>
                                    <SemanticTable.Cell>{barra.evento}</SemanticTable.Cell>
                                    <SemanticTable.Cell>{barra.id_curso}</SemanticTable.Cell>
                                    <SemanticTable.Cell>{barra.vagas_disponiveis}</SemanticTable.Cell>
                                    <SemanticTable.Cell>{barra.vagas_preenchidas}</SemanticTable.Cell>
                                    <SemanticTable.Cell>{barra.esgotado > 0 ? "Sim" : "Não"}</SemanticTable.Cell>
                                    <SemanticTable.Cell>{barra.atualiza > 0 ? "Sim" : "Não"}</SemanticTable.Cell>
                                    <SemanticTable.Cell>
                                        <div className="actions">
                                            <Button
                                                icon="edit icon"
                                                color={"blue"}
                                                onClick={() => {
                                                    setCurrentBarra(barra);
                                                    setEditModal(true);
                                                }}
                                            />
                                            <Button
                                                icon="delete icon"
                                                color={"red"}
                                                onClick={async () => {
                                                    setCurrentBarra(barra);
                                                    setDeleteModal(true);
                                                }}
                                            />
                                        </div>
                                    </SemanticTable.Cell>
                                </SemanticTable.Row>
                            ))}
                    </SemanticTable.Body>
                </SemanticTable>
                <Modal
                    closeIcon
                    open={addModal}
                    onClose={() => setAddModal(false)}
                >
                    <Header icon="add" content="Adicionar uma nova barra" />
                    <Modal.Content>
                        <Form>
                            <div>
                                <label>Evento: </label>
                                <input
                                    type="text"
                                    value={newBarra.evento}
                                    onChange={e => {
                                        setNewBarra({ ...newBarra, evento: e.target.value });
                                    }}
                                />
                            </div>
                            <div>
                                <label>ID do curso: </label>
                                <input
                                    type="number"
                                    value={newBarra.id_curso}
                                    onChange={e => {
                                        setNewBarra({ ...newBarra, id_curso: e.target.value });
                                    }}
                                />
                            </div>
                            <div>
                                <label>Vagas disponíveis: </label>
                                <input
                                    type="number"
                                    value={newBarra.vagas_disponiveis}
                                    onChange={e => {
                                        setNewBarra({ ...newBarra, vagas_disponiveis: e.target.value });
                                    }}
                                />
                            </div>
                            <div>
                                <label>Vagas preenchidas: </label>
                                <input
                                    type="number"
                                    value={newBarra.vagas_preenchidas}
                                    onChange={e => {
                                        setNewBarra({ ...newBarra, vagas_preenchidas: e.target.value });
                                    }}
                                />
                            </div>
                            <div>
                                <label>Esgotado?: </label>
                                <select
                                    onChange={e => {
                                        setNewBarra({ ...newBarra, esgotado: e.target.value });
                                    }}
                                >
                                    <option selected value={0}>Não</option>
                                    <option value={1}>Sim</option>
                                </select>
                            </div>
                            <div>
                                <label>Escala com o tempo?: </label>
                                <select
                                    onChange={e => {
                                        setNewBarra({ ...newBarra, atualiza: e.target.value });
                                    }}
                                >
                                    <option value={1}>Sim</option>
                                    <option selected value={0}>Não</option>
                                </select>
                            </div>
                        </Form>
                    </Modal.Content>
                    <Modal.Actions>
                        <Button
                            color="green"
                            onClick={() => {
                                createBarra();
                            }}
                        >
                            <Icon name="checkmark" /> Confirmar
                        </Button>
                        <Button
                            color="red"
                            onClick={() => {
                                setAddModal(false);
                            }}
                        >
                            <Icon name="remove" /> Cancelar
                        </Button>
                    </Modal.Actions>
                </Modal>
                <Modal
                    closeIcon
                    open={editModal}
                    onClose={() => setEditModal(false)}
                >
                    <Header icon="edit" content="Editando uma barra" />
                    <Modal.Content>
                        <Form>
                            <div>
                                <label>ID: </label>
                                <input
                                    type="text"
                                    value={currentBarra.id}
                                    readonly
                                />
                            </div>
                            <div>
                                <label>Evento: </label>
                                <input
                                    type="text"
                                    value={currentBarra.evento}
                                    onChange={e => {
                                        setCurrentBarra({ ...currentBarra, evento: e.target.value });
                                    }}
                                />
                            </div>
                            <div>
                                <label>ID do curso: </label>
                                <input
                                    type="number"
                                    value={currentBarra.id_curso}
                                    onChange={e => {
                                        setCurrentBarra({ ...currentBarra, id_curso: e.target.value });
                                    }}
                                />
                            </div>
                            <div>
                                <label>Vagas disponíveis: </label>
                                <input
                                    type="number"
                                    value={currentBarra.vagas_disponiveis}
                                    onChange={e => {
                                        setCurrentBarra({ ...currentBarra, vagas_disponiveis: e.target.value });
                                    }}
                                />
                            </div>
                            <div>
                                <label>Vagas preenchidas: </label>
                                <input
                                    type="number"
                                    value={currentBarra.vagas_preenchidas}
                                    onChange={e => {
                                        setCurrentBarra({ ...currentBarra, vagas_preenchidas: e.target.value });
                                    }}
                                />
                            </div>
                            <div>
                                <label>Esgotado?: </label>
                                <select
                                    onChange={e => {
                                        setCurrentBarra({ ...currentBarra, esgotado: e.target.value });
                                    }}
                                >
                                    {currentBarra.esgotado > 0 ? (
                                        <>
                                            <option value={0}>Não</option>
                                            <option selected value={1}>Sim</option>
                                        </>
                                    ) : (
                                        <>
                                            <option selected value={0}>Não</option>
                                            <option value={1}>Sim</option>
                                        </>
                                    )}
                                </select>
                            </div>
                            <div>
                                <label>Escala com o tempo?: </label>
                                <select
                                    onChange={e => {
                                        setCurrentBarra({ ...currentBarra, atualiza: e.target.value });
                                    }}
                                >
                                    {currentBarra.atualiza > 0 ? (
                                        <>
                                            <option selected value={1}>Sim</option>
                                            <option value={0}>Não</option>
                                        </>
                                    ) : (
                                        <>
                                            <option value={1}>Sim</option>
                                            <option selected value={0}>Não</option>
                                        </>
                                    )}
                                </select>
                            </div>
                        </Form>
                    </Modal.Content>
                    <Modal.Actions>
                        <Button
                            color="green"
                            onClick={() => {
                                editBarra();
                            }}
                        >
                            <Icon name="checkmark" /> Alterar
                        </Button>
                        <Button
                            color="red"
                            onClick={() => {
                                setEditModal(false);
                            }}
                        >
                            <Icon name="remove" /> Cancelar
                        </Button>
                    </Modal.Actions>
                </Modal>
                <Modal
                    closeIcon
                    open={deleteModal}
                    onClose={() => setDeleteModal(false)}
                >
                    <Header icon="delete" content="Excluindo uma barra" />
                    <Modal.Content>
                        <Form>
                            <div>
                                <label>A barra com as seguintes informações será excluída:</label>
                            </div>
                            <div>
                                <label>ID: </label>
                                <input
                                    type="text"
                                    value={currentBarra.id}
                                    readonly
                                />
                            </div>
                            <div>
                                <label>Evento: </label>
                                <input
                                    type="text"
                                    value={currentBarra.evento}
                                    readonly
                                />
                            </div>
                            <div>
                                <label>ID do curso: </label>
                                <input
                                    type="number"
                                    value={currentBarra.id_curso}
                                    readonly
                                />
                            </div>
                            <div>
                                <label>Vagas disponíveis: </label>
                                <input
                                    type="number"
                                    value={currentBarra.vagas_disponiveis}
                                    readonly
                                />
                            </div>
                            <div>
                                <label>Vagas preenchidas: </label>
                                <input
                                    type="number"
                                    value={currentBarra.vagas_preenchidas}
                                    readonly
                                />
                            </div>
                            <div>
                                <label>Esgotado?: </label>
                                <select>
                                    {currentBarra.esgotado > 0 ? (
                                        <>
                                            <option value="0">Não</option>
                                            <option selected value="1">Sim</option>
                                        </>
                                    ) : (
                                        <>
                                            <option selected value="0">Não</option>
                                            <option value="1">Sim</option>
                                        </>
                                    )}
                                </select>
                            </div>
                            <div>
                                <label>Escala com o tempo?: </label>
                                <select>
                                    {currentBarra.atualiza > 0 ? (
                                        <>
                                            <option selected value="1">Sim</option>
                                            <option value="0">Não</option>
                                        </>
                                    ) : (
                                        <>
                                            <option value="1">Sim</option>
                                            <option selected value="0">Não</option>
                                        </>
                                    )}
                                </select>
                            </div>
                        </Form>
                    </Modal.Content>
                    <Modal.Actions>
                        <Button
                            color="green"
                            onClick={() => {
                                deleteBarra();
                            }}
                        >
                            <Icon name="checkmark" /> Excluir
                        </Button>
                        <Button
                            color="red"
                            onClick={() => {
                                setDeleteModal(false);
                            }}
                        >
                            <Icon name="remove" /> Cancelar
                        </Button>
                    </Modal.Actions>
                </Modal>
            </Content>
        </Container>
    )
}

export default withRouter(BarrasEventos);